module.exports = __webpack_public_path__ + "img/thumb_29.ccd2a9c1.jpg";